import styled from 'react-emotion';
import { BaseTable } from '../../Symbols/BaseTable';
import Title from '../../Symbols/Title';

export const MainTitle = styled(Title)`
	margin-top: 22px;
`;

export const Subtitle = styled.h3`
	font-weight: 600;
	color: rgb(89, 89, 89);
	font-size: 0.875rem;
	margin: 0px;
	border-bottom: none;
	flex: 0 0 60%;

	@media (max-width: 480px) {
		flex: 0 0 100%;
	}
`;

export const Line = styled.div`
	border-bottom: 1px solid #d9d9d9;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	margin-bottom: 10px;
	padding-bottom: 10px;
`

export const ButtonMore = styled.div`
	flex: 0 0 40%;
	
	button {
		margin-bottom: 0;
		margin-right: 0;
		margin-left: auto;
	}
	
	@media (max-width: 480px) {
		flex: 0 0 100%;
		
		button {
			width: 100%;
			margin: 10px auto;
			padding-left: 0;
			padding-right: 0;
		}
	}
`

export const Candidates = styled(BaseTable)`
	margin-top: 1.315rem;
	margin-bottom: 2rem;
	
	thead {
		background-color: transparent;
	}
	
	thead tr td {
		padding: 0;
	}
	
	tr {
		border-width: 0;
	}

	td {
		padding: 0.2rem 0.5rem;
		font-size: 0.9rem;
		font-weight: 300;
		text-align: left;
	}

	td:first-child {
		width: 50%;
	}
	
	tbody tr:nth-child(odd) {
		background-color: #fff;
	}

	tbody tr:nth-child(even) {
		background-color: #f2f2f2;
	}

	@media (max-width: 480px) {
		td {
			padding: 0.2rem;
			font-size: 0.8125rem;
			flex-wrap: wrap;
		}
	}
`;
